module.exports = __webpack_public_path__ + "img/Oval.6b2dcef6.svg";